var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('rect',{attrs:{"x":"11.722","y":"4.7885","width":".557","height":"14.423","stroke-width":"0"}}),_c('rect',{attrs:{"transform":"rotate(90)","x":"4.7885","y":"-16.812","width":".557","height":"9.623","stroke-width":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }